import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { CategoryGrid } from '@/components/CategoryGrid';
import { MealsSlider } from '@/components/MealsSlider';
import { Footer } from '@/components/Footer';
import { BackToTop } from '@/components/BackToTop';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import { AccessibilityWidget } from '@/components/AccessibilityWidget';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Hero />
      <CategoryGrid />
      <MealsSlider />
      <Footer />
      <BackToTop />
      <WhatsAppButton phoneNumber="972501234567" />
      <AccessibilityWidget />
    </div>
  );
};

export default Index;
